export const environment = {
  production: false,
  apiUrl: 'https://apidev.somosredal.app.br',

  // CMS
  jwtSecretKeyCms: 'L3kkwcEZXqv+NSVu2lrjGRhdWnUxz59FJWmbpyX1DNVEFd+8CbCnqwP1aFqTdcvXu7tEqMG9JdS23JdS',

  // flags
  skipAuth: false,
};
